import p1Desk from '../assets/projects/p-1-desktop.png';
import p1Mob from '../assets/projects/p-1-mobile.png';
import p2Desk from '../assets/projects/p-2-desktop.png';
import p2Mob from '../assets/projects/p-2-mobile.png';
import p3Desk from '../assets/projects/p-3-desktop.png';
import p3Mob from '../assets/projects/p-3-mobile.png';
import p4Desk from '../assets/projects/p-4-desktop.png';
import p4Mob from '../assets/projects/p-4-mobile.png';
import p5Desk from '../assets/projects/p-5-desktop.png';
import p5Mob from '../assets/projects/p-5-mobile.png';
import p6Desk from '../assets/projects/p-6-desktop.png';
import p6Mob from '../assets/projects/p-6-mobile.png';

const projects = [
  {
    id: 1,
    name: 'Bug Tracker',
    description: 'Bug Tracking app, features team-work support.',
    desktopImage: p1Desk,
    mobileImage: p1Mob,
    stack: [
      'TypeScript',
      'React',
      'Redux',
      'Node.js',
      'Express.js',
      'PostgreSQL',
    ],
    codeUrl: 'https://github.com/amand33p/bug-tracker',
    liveUrl: 'https://abugtracker.netlify.app',
  },
  {
    id: 2,
    name: 'Stack Underflow',
    description: 'Feature-rich ‘stack overflow’ (QnA site) clone. ',
    desktopImage: p2Desk,
    mobileImage: p2Mob,
    stack: ['React', 'Node.js', 'GraphQL', 'Apollo', 'MongoDB'],
    codeUrl: 'https://github.com/amand33p/stack-underflow',
    liveUrl: 'https://stackunderflow.netlify.app',
  },
  {
    id: 3,
    name: 'LesChat!',
    description:
      'Real-time chat app, features private, global and group chatting.',
    desktopImage: p3Desk,
    mobileImage: p3Mob,
    stack: ['React', 'Node.js', 'GraphQL', 'Apollo', 'PostgreSQL'],
    codeUrl: 'https://github.com/amand33p/les-chat',
    liveUrl: 'https://leschat.netlify.app',
  },
  {
    id: 4,
    name: 'Reddish',
    description: 'Simplified Reddit (popular social-media site) clone.',
    desktopImage: p4Desk,
    mobileImage: p4Mob,
    stack: ['React', 'Redux', 'Node.js', 'Express.js', 'MongoDB'],
    codeUrl: 'https://github.com/amand33p/reddish',
    liveUrl: 'https://reddish.netlify.app',
  },
  {
    id: 5,
    name: 'Profile Store',
    description: 'Store profile URLs of people you admire at one place.',
    desktopImage: p5Desk,
    mobileImage: p5Mob,
    stackTitle: 'MERN',
    stack: ['React', 'Node.js', 'Express.js', 'MongoDB'],
    codeUrl: 'https://github.com/amand33p/profile-store',
    liveUrl: 'https://profile-store.netlify.app',
  },
  {
    id: 6,
    name: 'To-View-List',
    description:
      'Keep track of online stuff, which you may want to view later.',
    desktopImage: p6Desk,
    mobileImage: p6Mob,
    stackTitle: 'MERN',
    stack: ['React', 'Context API', 'Node.js', 'Express.js', 'MongoDB'],
    codeUrl: 'https://github.com/amand33p/to-view-list',
    liveUrl: 'https://toviewlist.netlify.app',
  },
];

export default projects;
